import React, { useState } from 'react';
import './TeamAvailability.css';
import './AvailabilityQuickLook.css';

const AvailabilityToggles = ({member, data, onChange,...props}) => {
  const { status } = data;
  const [isUpdating, setIsUpdating] = useState(false);
  const handleStateChangeClick = async function (e) {
    const newStatus = e.target.id;
    if (status !== newStatus) {
      setIsUpdating(true);
      await onChange(member.id, newStatus);
      setIsUpdating(false);
    }
  };
  if (data.editable) {
    return (
    <div className="flex-grow-1 px-sm-2 AvailabilityQuickLook">
      {props.singular ? "" : <h3 className={`d-inline-block my-1`}>
        {" "}{member.last_name}, {member.first_name}{" "}
      </h3> }
      {isUpdating && (
        <div className="d-inline ms-2 text-primary">
          <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
          Updating&hellip;
        </div>
      )}
      <ul className="GameRoster-availability m-0">
        <li onClick={handleStateChangeClick} id="available" className={`Availability-button availability-available ${status === "available" ? "active" : ""}`} title="Available">
          {/* <a>
            <i className="fa fa-check"></i>
          </a> */}
          <span> YES </span>
        </li>
        <li onClick={handleStateChangeClick} id="undecided" className={`Availability-button availability-undecided ${status === "undecided" ? "active" : ""}`} title="Undecided">
          {/* <a>
            <i className="fa fa-question"></i>
          </a> */}
          <span> MAYBE </span>
        </li>
        <li onClick={handleStateChangeClick} id="unavailable" className={`Availability-button availability-unavailable ${status === "unavailable" ? "active" : ""}`} title="Unavailable">
          {/* <a>
            <i className="fa fa-ban"></i>
          </a> */}
          <span> NO </span>
        </li>
      </ul>
    </div>
      )
  } else {
    const userStatus = status;
    let showOnScreen;
    if (userStatus === "available") {
      showOnScreen = (
        <li id="available" style={{ marginLeft: "auto", width: "75px" }} className={`Availability-button availability-available  ${status === "available" ? "active" : ""}`} title="Available">
          {/* <a>
            <i className="fa fa-check"></i>
          </a> */}
          <span> ATTENDED </span>
        </li>
      );
    }
    else if (userStatus === "undecided") {
      showOnScreen = (
        <li id="undecided" style={{ marginLeft: "auto", width: "75px" }} className={`Availability-button availability-undecided ${status === "undecided" ? "active" : ""}`} title="Undecided">
          {/* <a>
            <i className="fa fa-question"></i>
          </a> */}
          <span> UNDECIDED </span>
        </li>
      );
    }
    else {
      showOnScreen = (
        <li id="unavailable" style={{ marginLeft: "auto", width: "75px" }} className={`Availability-button availability-unavailable ${status === "unavailable" ? "active" : ""}`}
          title="Unavailable"
        >
          {/* <a>
            <i className="fa fa-ban"></i>
          </a> */}
          <span> UNAVAILABLE </span>
        </li>
      );
    }
    if (props.singular ) {
      return (
        <div>
          <ul className="text-end m-0 p-0 singleAvailability">{showOnScreen}</ul>
        </div>
      )
    }
    return (
      <div className="flex-grow-1 pt-2">
      <div className="d-flex align-items-center justify-content-between justify-content-md-center align-content-center mb-1">
        <h3 className={`d-inline-block m-0` }>
          {member.last_name}, {member.first_name}
        </h3>
        <ul className="text-end m-0" style={{marginLeft:"auto"}}>
          {showOnScreen}
        </ul>
      </div>
      </div>
    );
  }
};

export default AvailabilityToggles;